// extracted by mini-css-extract-plugin
module.exports = {"container":"answer-container_container__1zGud","header":"answer-container_header__mqROo","fill":"answer-container_fill__3CXWv"};